import {Callback} from "../core/Reflection";
import {PngSequence} from "./PngSequence";

export class MagicPoof extends PngSequence {

    constructor(cb?: Callback) {
        super("magicpoof-{1}");
        this.anchor.x = 0.5;
        this.anchor.y = 0.52;
        this.loop = false;
        if (cb) {
            this.onComplete = cb;
        }
        this.scale.set(4);
        this.animationSpeed = 0.4;
        this.play();
    }
}
